import type { ClientDTO, ClientDetailDTO, ContactDTO, Paginated } from '@copilot/shared';
import { api } from './client';
import type { ClientBody, ClientPatch, ContactBody } from './types';

const enc = encodeURIComponent;

export const clientsApi = {
  list: (params: { q?: string; page?: number; pageSize?: number }) =>
    api<Paginated<ClientDTO>>('/clients', { query: params }),
  get: (id: string) => api<ClientDetailDTO>(`/clients/${enc(id)}`),
  create: (body: ClientBody) => api<ClientDTO>('/clients', { method: 'POST', body }),
  patch: (id: string, body: ClientPatch) => api<ClientDTO>(`/clients/${enc(id)}`, { method: 'PATCH', body }),
  merge: (id: string, sourceClientId: string) =>
    api<void>(`/clients/${enc(id)}/merge`, { method: 'POST', body: { sourceClientId } }),
  deleteAllData: (id: string) => api<void>(`/clients/${enc(id)}/data`, { method: 'DELETE' }),
  addContact: (clientId: string, body: ContactBody) =>
    api<ContactDTO>(`/clients/${enc(clientId)}/contacts`, { method: 'POST', body }),
  patchContact: (id: string, body: Partial<ContactBody>) =>
    api<ContactDTO>(`/contacts/${enc(id)}`, { method: 'PATCH', body }),
  deleteContact: (id: string) => api<void>(`/contacts/${enc(id)}`, { method: 'DELETE' }),
};
